export default __webpack_public_path__ + "static/media/drum-mach.c0746147.JPG";